import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CardComponent} from '../sidenav/card/card.component';
import {ServicesSideCardsComponent} from './services-side-cards/services-side-cards.component';
import {TranslateModule} from '@ngx-translate/core';
import {ReactiveFormsModule} from '@angular/forms';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {NgbActiveModal, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import {NgxMaskModule} from 'ngx-mask';
import {TabBarComponent} from './tab-bar/tab-bar.component';
import {SidenavComponent} from '../sidenav/sidenav.component';
import {SortableDirective} from '../_directives/sortable.directive';
import {ConfirmComponent} from './modals/confirm/confirm.component';
import {ValidationErrorsComponent} from './forms/validation-errors/validation-errors.component';
import {PhoneFormRowComponent} from './forms/phone-form-row/phone-form-row.component';
import {RequiredComponent} from './forms/required/required.component';
import {PdfButtonBarComponent} from './pdf-button-bar/pdf-button-bar.component';
import {IconButtonComponent} from './icon-button/icon-button.component';
import {ReportsServicesBaseComponent} from './reports-services-base.component';
import {TermsComponent} from '../footer/terms/terms.component';
import {RouterModule} from '@angular/router';
import {ResetPasswordComponent} from '../admin/user-admin/reset-password/reset-password.component';
import {AriaAttrsParentDirective} from '../_directives/aria-attrs-parent.directive';
import {HideOnBlurDirective} from '../_directives/hide-on-blur.directive';
import {PdfReactorHeaderComponent} from './pdf-reactor-header/pdf-reactor-header.component';

@NgModule({
    imports: [
        //
        // Don't put TUD modules in this module as that will almost definitely cause a circular dependency (this module is imported in basically all others)
        //
        CommonModule,
        FontAwesomeModule,
        TranslateModule.forChild(),
        NgxMaskModule.forChild(),
        RouterModule,
        ReactiveFormsModule,
        NgbTooltipModule,
        CardComponent,
        ServicesSideCardsComponent,
        TabBarComponent,
        SidenavComponent,
        SortableDirective,
        ConfirmComponent,
        ValidationErrorsComponent,
        PhoneFormRowComponent,
        RequiredComponent,
        PdfButtonBarComponent,
        IconButtonComponent,
        ReportsServicesBaseComponent,
        TermsComponent,
        ResetPasswordComponent,
        AriaAttrsParentDirective,
        HideOnBlurDirective,
        PdfReactorHeaderComponent
    ],
    providers: [NgbActiveModal, ConfirmComponent],
    exports: [
        CardComponent,
        ServicesSideCardsComponent,
        TabBarComponent,
        SidenavComponent,
        SortableDirective,
        ConfirmComponent,
        ValidationErrorsComponent,
        PhoneFormRowComponent,
        RequiredComponent,
        PdfButtonBarComponent,
        IconButtonComponent,
        ReportsServicesBaseComponent,
        TermsComponent,
        ResetPasswordComponent,
        AriaAttrsParentDirective,
        HideOnBlurDirective,
        PdfReactorHeaderComponent
    ]
})
export class CommonTudComponentsModule {}
